import { render, staticRenderFns } from "./StatementView.vue?vue&type=template&id=4081a776&scoped=true"
import script from "./StatementView.vue?vue&type=script&lang=js"
export * from "./StatementView.vue?vue&type=script&lang=js"
import style0 from "./StatementView.vue?vue&type=style&index=0&id=4081a776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4081a776",
  null
  
)

export default component.exports